import { PmsProductDto } from './../interfaces/dto/pms-product.dto';
import { Injectable } from '@angular/core';
import {Observable, of} from 'rxjs';
import {Practice} from '../models/Practice';
import {PaymentDto} from '../interfaces/dto/payment.dto';
import {map} from 'rxjs/operators';
import {EnvironmentService} from '../services/environment.service';
import {HttpClient} from '@angular/common/http';
import { PmsProduct } from '../interfaces/pms-product.interface';
import { PmsProductAdapter } from '../adapters/pms-product.adapter';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  constructor(
    private environmentService: EnvironmentService,
    private http: HttpClient,
    private adapter: PmsProductAdapter,
  ) { }

  getProducts(practice: Practice | null): Observable<PmsProduct[]> {
    if (!practice) {
      return of([]);
    }

    const url = this.environmentService.get('backendUrl') + `/practices/${practice.id}/pms-products`;

    return this.http.get<PmsProductDto[]>(url, {
      withCredentials: true,
    }).pipe(
      map((response: PmsProductDto[]) => {
        return response.map(p => this.adapter.run(p));
      })
    );
  }
}
